var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"mb-5 d-block",attrs:{"href":_vm.nextLink}},[_vm._v("Click on this link to sign in with Xumm")]),_vm._v(" "),_c('p',{staticClass:"mb-5"},[_vm._v("or scan this code in your XUMM app")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.qr,"alt":"QR Code"}}),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }